import BaseModel from '../core/BaseModel'
export default class MediaModel extends BaseModel {
    constructor() {
        super({ 
                name: "media",
                tableName: 'core_media'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}